import { fromJS } from "immutable";

export default {
	pageName: "userSettingsNotifications",
	asapAndDeferredOptions: [
		{ label: "As Soon As Possible", name: "asap" },
		{ label: "Daily", name: "deferred" },
		{ label: "Off", name: null },
	],
	digestOptions: [
		{ label: "On", name: "digest" },
		{ label: "Off", name: null },
	],
	adminDigestOptions: [
		{ label: "On", name: "adminDigest" },
		{ label: "Off", name: null },
	],
	dailyNotificationsOptions: fromJS([
		{ id: "not-set", label: "", isSelectable: false },
		{ id: "once", label: "Once a day" },
		{ id: "twice", label: "Twice a day" },
	]),
	timeOptions: fromJS([
		{ id: "9", label: "Morning" },
		{ id: "12", label: "Mid-Day" },
		{ id: "16", label: "Afternoon" },
		{ id: "19", label: "Evening" },
	]),
	digestTimeOptions: fromJS([
		{ id: "9", label: "Morning" },
		{ id: "12", label: "Mid-Day" },
		{ id: "16", label: "Afternoon" },
		{ id: "19", label: "Evening" },
	]),
	meridiemOptions: fromJS([
		{ id: "am", label: "AM" },
		{ id: "pm", label: "PM" },
	]),
	dayOfTheWeekOptions: fromJS([
		{ id: "sunday", label: "Sunday" },
		{ id: "monday", label: "Monday" },
		{ id: "tuesday", label: "Tuesday" },
		{ id: "wednesday", label: "Wednesday" },
		{ id: "thursday", label: "Thursday" },
		{ id: "friday", label: "Friday" },
		{ id: "saturday", label: "Saturday" },
	]),
};
